/* Ondéa Pro : enchaînement du film d'ouverture.
   - une scène par chapitre, durée fixe (data-duration, en ms) ;
   - la barre du chapitre en cours se remplit au rythme réel (rAF) ;
   - lecture seulement quand le film est à l'écran et l'onglet visible ;
   - bouton pause / lecture (obligatoire pour un mouvement de plus de 5 s) ;
   - mouvement réduit : pas de lecture automatique, les chapitres restent
     cliquables et chaque scène s'affiche directement dans son état final.
   La classe oph--js est posée par un script en ligne au tout début de la
   section (avant l'affichage), pour que le titre n'apparaisse pas puis
   disparaisse : ici on ne fait que déclencher son entrée (is-in). */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-ch-i]'));
    var scenes = Array.prototype.slice.call(root.querySelectorAll('[data-sc]'));
    var caps = Array.prototype.slice.call(root.querySelectorAll('[data-cap]'));
    var fills = chapters.map(function (b) { return b.querySelector('.ofm-ch__fill'); });
    var toggle = root.querySelector('[data-ofm-toggle]');
    var D = parseInt(root.getAttribute('data-duration'), 10) || 5200;
    if (!chapters.length) return;

    root.classList.add('ofm--js');
    root.style.setProperty('--n', chapters.length);

    var cur = -1, t = 0, playing = !reduce, inView = false, raf = 0, last = 0;

    function show(i) {
      cur = i; t = 0;
      var name = chapters[i].getAttribute('data-scene');
      scenes.forEach(function (s) {
        if (s.getAttribute('data-sc') === name) {
          /* Retirer puis remettre la classe relance les animations de la scène. */
          s.classList.remove('is-on');
          void s.getBoundingClientRect();
          s.classList.add('is-on');
        } else {
          s.classList.remove('is-on');
        }
      });
      caps.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
      chapters.forEach(function (b, k) {
        b.setAttribute('aria-current', k === i ? 'true' : 'false');
        fills[k].style.transform = 'scaleX(' + (k < i ? 1 : 0) + ')';
      });
    }

    function frame(now) {
      var dt = Math.min(now - last, 64);
      last = now;
      t += dt;
      fills[cur].style.transform = 'scaleX(' + Math.min(1, t / D).toFixed(4) + ')';
      if (t >= D) show((cur + 1) % chapters.length);
      raf = requestAnimationFrame(frame);
    }
    function run() { if (!raf) { last = performance.now(); raf = requestAnimationFrame(frame); } }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }

    function state() {
      var live = playing && inView && !document.hidden;
      root.classList.toggle('is-paused', !playing);
      root.classList.toggle('is-off', !inView || document.hidden);
      if (toggle) {
        toggle.setAttribute('aria-label', playing ? toggle.getAttribute('data-pause') : toggle.getAttribute('data-play'));
        toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
      }
      if (live) run(); else stop();
    }

    chapters.forEach(function (b, i) {
      b.addEventListener('click', function () { show(i); state(); });
    });
    if (toggle) toggle.addEventListener('click', function () { playing = !playing; state(); });
    document.addEventListener('visibilitychange', state);

    if (reduce && toggle) toggle.hidden = true;
    show(0);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        state();
      }, { threshold: 0.35 }).observe(root);
    } else {
      inView = true;
      state();
    }
  }

  function init() {
    document.querySelectorAll('[data-oph]').forEach(function (h) {
      requestAnimationFrame(function () { requestAnimationFrame(function () { h.classList.add('is-in'); }); });
    });
    document.querySelectorAll('[data-ofm]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();